import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';

interface EditBookingConfirmDialogProps {
  open: boolean;
  onCancel: () => void;
  /** Edit only the selected booking */
  onEditThisBooking: () => void;
  /** Edit the selected booking and all future bookings in the group */
  onEditAllFutureBookings: () => void;
}

export function EditBookingConfirmDialog({
  open,
  onCancel,
  onEditThisBooking,
  onEditAllFutureBookings,
}: EditBookingConfirmDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={(isOpen) => !isOpen && onCancel()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Edit Recurring Booking</AlertDialogTitle>
          <AlertDialogDescription>
            Are you sure you want to edit booking?
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="flex-col sm:flex-row gap-2">
          <AlertDialogCancel onClick={onCancel}>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={onEditThisBooking}
            className="bg-primary text-primary-foreground hover:bg-primary/90"
          >
            This booking?
          </AlertDialogAction>
          <AlertDialogAction
            onClick={onEditAllFutureBookings}
            className="bg-primary text-primary-foreground hover:bg-primary/90"
          >
            All future bookings?
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
